import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

export function StatTile({
    label,
    value,
    icon: Icon,
    accent = false,
    className,
}: {
    label: string;
    value: string | number;
    icon?: LucideIcon;
    accent?: boolean;
    className?: string;
}) {
    return (
        <div
            className={cn(
                "bg-bg-surface border border-white/5",
                "px-4 py-3",
                "shadow-[0_10px_30px_rgba(0,0,0,0.6)]",
                "flex flex-col justify-between gap-2 h-full rounded-2xl",
                className
            )}
        >
            <div className="flex items-center justify-between">
                <div className="text-[10px] font-black uppercase tracking-widest text-text-muted">
                    {label}
                </div>
                {Icon ? (
                    <div className={cn(
                        "h-8 w-8 rounded-lg grid place-items-center",
                        "border",
                        accent ? "text-gold-400 border-gold-500/30 bg-gold-500/10" : "text-white/80 border-white/10 bg-white/5"
                    )}>
                        <Icon className="h-4 w-4" />
                    </div>
                ) : null}
            </div>

            <div className={cn(
                "mt-1 font-black tracking-tighter",
                "text-3xl",
                "font-data",
                accent ? "text-gold-400 drop-shadow-[0_0_8px_rgba(212,175,55,0.4)]" : "text-white"
            )}>
                {value}
            </div>
        </div>
    );
}
